import React from "react";
import {
  Button,
  SanityImage,
  SectionTitleHeading,
  SanityImageRatio,
  SectionContainer,
  SectionTitle
} from "@silversea-ssc/ui-components-react";
import * as styles from "./TravelGuide.module.scss";
import { ImageFragment } from "types/graphql-types";

export interface TravelGuideProps {
  sectionTitle?: string;
  image?: ImageFragment;
  guideTitle?: string;
  content?: string;
  url?: string;
  ctaText?: string;
}

const TravelGuide: React.FC<TravelGuideProps> = ({
  sectionTitle,
  image,
  guideTitle,
  content,
  url,
  ctaText
}) => (
  <div
    id="travel_guide"
    className={styles.travelGuide}
    data-content-name="travel_guide"
  >
    <SectionContainer backgroundColor="destination">
      <SectionTitle variant="wide" textColor="white">
        <SectionTitleHeading className={styles.title}>
          {sectionTitle}
        </SectionTitleHeading>
      </SectionTitle>
      <div className={styles.section}>
        <div className={styles.imgContainer}>
          <div className={styles.imgContainerWrapper}>
            {image && (
              <SanityImageRatio image={image} ratio="auto">
                <SanityImage image={image} />
              </SanityImageRatio>
            )}
          </div>
        </div>
        <div className={styles.content}>
          <h3 className={styles.subtitle}>{guideTitle}</h3>
          <p className={styles.paragraph}>{content}</p>
          <div className={styles.footer}>
            <Button
              variant="primary"
              data-content-piece="view_the_brochures"
              href={url}
            >
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </SectionContainer>
  </div>
);

export default TravelGuide;
